<div class="notification-auto-order-container">

  @if (getIsComponentLoading) {
    @if (showErrorPanel) {
      <div class="header">Error Information</div>

      <div [class.order-failure-panel]="hasFailureContent">
        @if (getNotification.response) {
          <p class="error-summary">{{ getNotification.response }}</p>
        }
        @if (failingItems.length > 0) {
          <div class="failing-items-section">
            <div class="failing-items-heading">Failing items</div>
            <ul class="failing-items-list">
              @for (item of failingItems; track item.stockCode) {
                <li class="failing-item">
                  <span class="stock-code">{{ item.stockCode }}</span>
                  <span class="item-desc">{{ item.desc }}</span>
                </li>
              }
            </ul>
            @for (guidance of itemErrorGuidance; track guidance.reason) {
              <p class="guidance-text">{{ guidance.guidance }}</p>
            }
          </div>
        }
        <div class="error-actions">
          @if (canRetryOrder) {
            <app-shared-button
              [colour]="'primary'"
              [fill]="true"
              (buttonClicked)="onRetryOrderClick()">
              Retry order
            </app-shared-button>
          }
          @if (canRetryWithoutFailedItems) {
            <app-shared-button
              [colour]="'primary'"
              [fill]="false"
              (buttonClicked)="onRetryWithoutFailedItemsClick()">
              Retry without failed items
            </app-shared-button>
          }
        </div>
      </div>
    }
    <div class="content-container-main main-header">
      <div class="content-container">Supplier</div>
      <div class="content-container size-limit-200">Generated</div>
      <div class="content-container size-limit-150">Order #</div>
      <div class="content-container size-limit-50">
        <ng-container *ngTemplateOutlet="templateEmailStatus"></ng-container>
      </div>
      <div class="content-container size-limit-50">
        <ng-container *ngTemplateOutlet="templatePdfStatus"></ng-container>
      </div>
      <div class="content-container size-limit-50">
        <ng-container *ngTemplateOutlet="templateIQStatus"></ng-container>
      </div>
    </div>
    @if (getAutoOrder) {
      <div class="content-container-main">
        <div class="content-container">{{ getSupplierName }}</div>
        <div class="content-container size-limit-200">{{ getGeneratedDate }}</div>
        <div class="content-container size-limit-150">{{ getPurchaseOrderNo }}</div>
        <div class="content-container size-limit-50">
          <ng-container *ngTemplateOutlet="templateEmailVariations"></ng-container>
        </div>
        <div class="content-container size-limit-50">
          <ng-container *ngTemplateOutlet="templatePdfVariations"></ng-container>
        </div>
        <div class="content-container size-limit-50">
          <ng-container *ngTemplateOutlet="templateIQVariations"></ng-container>
        </div>
      </div>
      <div class="content-container-mobile">
        <div class="content-container">
          <div class="main-header">Supplier</div>
          <span></span>
          <div>
            {{ getSupplierName }}
          </div>
        </div>
        <div class="content-container">
          <div class="main-header">Generated</div>
          <span></span>
          <div>
            {{ getGeneratedDate }}
          </div>
        </div>
        <div class="content-container">
          <div class="main-header">Order #</div>
          <span></span>
          <div>
            {{ getPurchaseOrderNo }}
          </div>
        </div>
        <div class="content-container">
          <div class="main-header">
            <ng-container *ngTemplateOutlet="templateEmailStatus"></ng-container>
            Email Status
          </div>
          <span></span>
          <div>
            <ng-container *ngTemplateOutlet="templateEmailVariations"></ng-container>
          </div>
        </div>
        <div class="content-container">
          <div class="main-header">
            <ng-container *ngTemplateOutlet="templatePdfStatus"></ng-container>
            PDF Status
          </div>
          <span></span>
          <div>
            <ng-container *ngTemplateOutlet="templatePdfVariations"></ng-container>
          </div>
        </div>
        <div class="content-container">
          <div class="main-header">
            <ng-container *ngTemplateOutlet="templateIQStatus"></ng-container>
            IQ Status
          </div>
          <span></span>
          <div>
            <ng-container *ngTemplateOutlet="templateIQVariations"></ng-container>
          </div>
        </div>
      </div>
    } @else {
      <div class="content-container-main error">
        <div class="content-container">No Order Information Found, please contact support.</div>
      </div>
    }
    @if (showErrorPanel) {
      <div class="error-actions">
        <app-shared-button
          [colour]="'primary'"
          [fill]="true"
          (buttonClicked)="onOpenRelatedOrder()">
          Open order
        </app-shared-button>
      </div>
    }
  } @else {
    <div class="notification-loader">
      <app-shared-loading-g
        [animation]="animation">
      </app-shared-loading-g>
    </div>
  }


  <ng-template #templateEmailStatus>
    <app-display-icon
      [icon]="icons.emailVariant"
      [tooltip]="'Email Status'">
    </app-display-icon>
  </ng-template>

  <ng-template #templatePdfStatus>
    <app-display-icon
      [icon]="icons.pdfBox"
      [tooltip]="'PDF Status'">
    </app-display-icon>
  </ng-template>

  <ng-template #templateIQStatus>
    <app-display-icon
      [icon]="icons.logoIQ"
      [tooltip]="'IQ Status'">
    </app-display-icon>
  </ng-template>

  <ng-template #templateEmailVariations>
    <app-display-icon
      (click)="onStatusIconClick(getAutoOrder, 'emailStatus')"
      [colour]="getStatusIconColour(getAutoOrder, 'emailStatus')"
      [icon]="getStatusIcon(getAutoOrder, 'emailStatus')"
      [tooltip]="getStatusTooltip(getAutoOrder, 'emailStatus')">
    </app-display-icon>
  </ng-template>

  <ng-template #templatePdfVariations>
    <app-display-icon
      (click)="onStatusIconClick(getAutoOrder, 'pdfStatus')"
      [colour]="getStatusIconColour(getAutoOrder, 'pdfStatus')"
      [icon]="getStatusIcon(getAutoOrder, 'pdfStatus')"
      [tooltip]="getStatusTooltip(getAutoOrder, 'pdfStatus')">
    </app-display-icon>
  </ng-template>

  <ng-template #templateIQVariations>
    <app-display-icon
      (click)="onStatusIconClick(getAutoOrder, 'iqStatus')"
      [colour]="getStatusIconColour(getAutoOrder, 'iqStatus')"
      [icon]="getStatusIcon(getAutoOrder, 'iqStatus')"
      [tooltip]="getStatusTooltip(getAutoOrder, 'iqStatus')">
    </app-display-icon>
  </ng-template>

</div>
